import styles from './Copyright.module.scss';

const Copyright = (): JSX.Element => (
  <div className={styles.copyright}>
    <p className={styles.copyrightText}>
      <span className={styles.copyrightIcon}>©</span>
      2022 Medical, LLC. All Rights Reserved.
    </p>
  </div>
);

export default Copyright;
